module.exports = __webpack_public_path__ + "img/header-engagementRingsBestseller.c8b34fa.webp";